/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Button } from 'react-bootstrap';
import { FaBars, FaLeaf } from 'react-icons/fa';

const TopBar = props => {
  const { openNavBar } = props;

  return (
    <Navbar 
      className="shadow-sm py-2"
      style={{ 
        zIndex: 2, 
        position: 'relative', 
        backgroundColor: 'var(--navbar-bg)',
      }}
    >
      <div className="d-flex justify-content-between align-items-center w-100 px-3">
        <Button 
          variant="link" 
          onClick={openNavBar}
          className="p-1"
          style={{ color: 'var(--navbar-text)' }}
        >
          <FaBars size={20} />
        </Button>
        
        <div className="d-flex align-items-center">
          <FaLeaf className="me-2" style={{ color: 'var(--brand-light-green)' }} />
          <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--navbar-text)' }}>
            MOTOMCO
          </span>
        </div>
        
        <div style={{ width: '24px' }}></div> {/* Espaçador para centralizar o logo */}
      </div>
    </Navbar>
  );
};

TopBar.propTypes = {
  openNavBar: PropTypes.func.isRequired
};

export default TopBar;
